// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* modified */
.designer-tools-container {
	display: table-cell;
	width: 100%;
	max-width: 400px;
	min-width: 400px;
}

.designer-tools {
	position: relative;
	height: 75px;
	/*margin-top: 64px;*/
	padding: 8px 0;

	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	border-top: 1px solid #d5d5d5;
	/*border-bottom: 1px solid #d5d5d5;*/
}

.designer-tools-options {
	margin: 0 auto;
	padding: 0;
	text-align: center;
}

.designer-tools-options li {
	display: inline-block;
	margin: 0;
	padding: 4px 1.9%;

	font-size: 30px;
	font-size: 3rem;
	list-style: none;
	text-align: center;
}

.designer-tools-options li a, .designer-tools-options li a .fa {
	color: #555 !important;
}


`, "",{"version":3,"sources":["webpack://./assets/style/partials/designer-tools.css"],"names":[],"mappings":"AAAA,aAAa;AACb;CACC,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,oBAAoB;CACpB,cAAc;;CAEd,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;CAC/H,6BAA6B;CAC7B,oCAAoC;AACrC;;AAEA;CACC,cAAc;CACd,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,SAAS;CACT,iBAAiB;;CAEjB,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB","sourcesContent":["/* modified */\r\n.designer-tools-container {\r\n\tdisplay: table-cell;\r\n\twidth: 100%;\r\n\tmax-width: 400px;\r\n\tmin-width: 400px;\r\n}\r\n\r\n.designer-tools {\r\n\tposition: relative;\r\n\theight: 75px;\r\n\t/*margin-top: 64px;*/\r\n\tpadding: 8px 0;\r\n\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\tborder-top: 1px solid #d5d5d5;\r\n\t/*border-bottom: 1px solid #d5d5d5;*/\r\n}\r\n\r\n.designer-tools-options {\r\n\tmargin: 0 auto;\r\n\tpadding: 0;\r\n\ttext-align: center;\r\n}\r\n\r\n.designer-tools-options li {\r\n\tdisplay: inline-block;\r\n\tmargin: 0;\r\n\tpadding: 4px 1.9%;\r\n\r\n\tfont-size: 30px;\r\n\tfont-size: 3rem;\r\n\tlist-style: none;\r\n\ttext-align: center;\r\n}\r\n\r\n.designer-tools-options li a, .designer-tools-options li a .fa {\r\n\tcolor: #555 !important;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
